import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';
import PageTitle from 'ui/shared/Page/PageTitle';

const ApiDocsPage = dynamic(() => import('ui/pages/ApiDocs'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/api-docs">
      <PageTitle title="API Documentation"/>
      <ApiDocsPage/>
    </PageNextJs>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
